






@if (currentSite === 'seqirusb2b-uk') {
  @if (accountlocationrba?.currentUserAccountPermission=='MANAGE') {
    <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
      <div class="myprofile_content_location myprofile_location_us ">
        <div class="col-md-6 col-sm-12 col-xs-12 myprofile_locationheader">{{"location.uktitle" | cxTranslate}}</div>
        <div class="col-md-6 col-sm-12 col-xs-12 myprofile_locationmangeheader">
          <a class="anchorunderline" [routerLink]="['/organisation-location']">{{"location.ukmanageloctext" | cxTranslate}}<div class="global_blackarrow"></div></a>
        </div>
        <div class="col-md-12 col-sm-12 col-xs-12 myprofile_selectoptions">
          <div class="myprofile_locationsearch"> <i class="myprofile_global_searchicon"></i>
          <input type="search" #search placeholder="Search for locations" (keyup.enter)="applyFilter($event, searchValue)" [(ngModel)]="searchValue">
          <!-- id="myprofile_location_searchbox" -->
          <button (click)="applyFilter($event,search.value)">Search</button>
        </div>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 margin-T20">
        <div class="row myprofilelocation myprofile_us example-container ukmanagelocationtable">
          <table  class="ukmanageLocation-table" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">
            <ng-container matColumnDef="name">
              <th mat-header-cell  *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by name">
                {{"location.loclabel" | cxTranslate}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by weight">
                {{"location.addrlabel" | cxTranslate}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.address}} </td>
            </ng-container>
            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header  disableClear="true"sortActionDescription="Sort by number">
                {{"location.typelabel" | cxTranslate}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.type}} </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by symbol">
                {{"location.emaillabel" | cxTranslate}}
              </th>
              <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsuk;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumnsuk;"></tr>
          </table>
          @if (searchResultEmpty) {
            <div class="no-results-message">
              {{"location.norecordsmsg" | cxTranslate}}
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
} @else {
  <div class="col-md-12 col-sm-12 col-xs-12 no-padding myprofile_location_us_container">
    <div class="myprofile_content_location myprofile_location_us ">
      <div class="col-md-6 col-sm-12 col-xs-12 myprofile_locationheader">{{"location.ustitle" | cxTranslate}}</div>
      <div class="col-md-6 col-sm-12 col-xs-12 myprofile_locationmangeheader">
        <a class="anchorunderline" [routerLink]="['/organization-location']">{{"location.usmanageloctext" | cxTranslate}}<div class="global_blackarrow"></div></a>
      </div>
      <div class="col-md-12 col-sm-12 col-xs-12 myprofile_selectoptions">
        <div class="myprofile_locationsearch"> <i class="myprofile_global_searchicon"></i>
        <input type="search" #search placeholder="Search for locations" (keyup.enter)="applyFilter($event, searchValue)" [(ngModel)]="searchValue">
        <!-- id="myprofile_location_searchbox" -->
        <button (click)="applyFilter($event,search.value)">Search</button>
      </div>
    </div>
    <div class="col-md-12 col-sm-12 col-xs-12 margin-T20">
      <div class="row myprofilelocation myprofile_us example-container table-container">
        <table  class="demo-table custom_sort_us" mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)">
          <ng-container matColumnDef="type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by number">
              {{"location.typelabel" | cxTranslate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.type}} </td>
          </ng-container>
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by name">
              {{"location.namelabel" | cxTranslate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>
          <ng-container matColumnDef="address">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by weight">
              {{"location.addrlabel" | cxTranslate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.address}} </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear="true" sortActionDescription="Sort by symbol">
              {{"location.statuslabel" | cxTranslate}}
            </th>
            <td mat-cell *matCellDef="let element"> {{element.status}} </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        @if (searchResultEmpty) {
          <div class="no-results-message">
            {{"location.norecordsmsg" | cxTranslate}}
          </div>
        }
      </div>
    </div>
  </div>
</div>
}

